<template lang="pug">
  v-flex(xs12 md4)
    v-layout(row wrap)
      v-flex(xs12)
        div.headline.pb-5 Select Assignee
      v-flex(xs12)
        v-tooltip(
          bottom
          :disabled="hasTeammate"
        )
          template(slot="activator")
            v-autocomplete(
              v-model="selectedUser"
              label="Assignee"
              :items="completeTeammates"
              :search-input.sync="searchValue"
              :item-text="displayName"
              return-object
              :disabled="!hasTeammate"
            )
          span You can enable this option by being part of a team

        div(v-if="isReminderVisible")
          v-checkbox(
            v-model="isReminderChecked"
            label="Set up a reminder"
            color="primary"
          )

          div.subheading.pt-5(v-if="isReminderChecked") Send reminder via

          v-radio-group(
            v-if="isReminderChecked"
            v-model="selectedReminderType"
            row
          )
            v-radio(
              v-for="reminderType in reminderTypes"
              :key="reminderType.value"
              :value="reminderType.value"
              :onIcon="reminderType.icon"
              :offIcon="reminderType.icon"
              color="primary"
            )
</template>
<script>

import { createNamespacedHelpers, mapState } from 'vuex';
import { DEFAULT_TEAMMATES } from './../config/actions';

const {
  mapActions: mapCampaignActionsActions,
  mapGetters: mapCampaignActionsGetters,
  mapState: mapCampaignActionsState,
} = createNamespacedHelpers('campaignAction');

export default {
  data() {
    return {
      selectedUser: Object.keys(this.value).length ? this.value : null,
      searchValue: '',
      isReminderChecked: !!this.reminderType, // Displays the reminder selection
      reminderTypes: [
        { value: 'email', icon: 'email' },
        { value: 'text', icon: 'tablet_android' },
        { value: 'phone', icon: 'phone' },
      ],
      selectedReminderType: this.reminderType || 'email', // The desired method of reminder, defaults to email
    };
  },

  props: {
    /**
     * Whether the reminder is supposed to be visible
     */
    isReminderVisible: Boolean,
    /**
     * The desired reminder type
     */
    reminderType: String,
    /**
     * The desired assignee
     */
    value: Object,
  },

  computed: {
    ...mapCampaignActionsState(['teammates']),
    ...mapCampaignActionsGetters(['hasTeammate']),
    ...mapState({
      userInformation: state => state.userInformation.user,
    }),
    completeTeammates: {
      get() {
        // If there are no teammates, only populate the returned array with
        // the header and a single default option of 'Me'
        if (!this.hasTeammate) {
          return [
            { header: 'Select Assignee' },
            DEFAULT_TEAMMATES.find(defaultTeammate => defaultTeammate.first_name === 'Me'),
          ];
        }
        // If there are teammates, however, return all the teammates with the
        // headers and the default teammate options
        return [
          { header: 'Select Assignee' },
          ...DEFAULT_TEAMMATES,
          ...this.teammates,
        ];
      },
    },
  },

  created() {
    this.getTeammates(this.userInformation.id);
    if (!this.selectedUser) {
      this.selectedUser = this.getFirstValidTeammate(this.completeTeammates);
    }
  },

  watch: {
    // Watchers for the selected user and the prop
    selectedUser: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
    value: {
      handler(value) {
        this.selectedUser = value;
      },
      deep: true,
    },
    // Watchers for the desired reminder type
    selectedReminderType(value) {
      this.$emit('update:action-reminder', value);
    },
    isReminderChecked(value) {
      this.$emit('update:action-reminder', (value) ? this.selectedReminderType : '');
    },
  },

  methods: {
    ...mapCampaignActionsActions([
      'getTeammates',
    ]),
    displayName(item) {
      let displayString = '';
      displayString += item.first_name || '';
      displayString += (item.first_name && item.last_name) ? ' ' : '';
      displayString += item.last_name || '';
      return displayString;
    },
    /**
     * @param {Array} teammates, The array of Users
     * @returns {Object} The first valid teammate (valid being having a first name)
     *
     * The first valid teammate from the list of teammates
     */
    getFirstValidTeammate(teammates) {
      let counter = 0;
      let currentTeammate = null;
      while (teammates[counter] && !teammates[counter].first_name) {
        currentTeammate = teammates[++counter];
      }
      return currentTeammate;
    },
  },
};
</script>
